module.exports = __webpack_public_path__ + "img/Number=39.85edeed5.png";